import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import ResponsiveWalletTag from "./ResponsiveWalletTag";
import TextChangeBalance from "../../common/TextChangeBalance";
import TextTotalBalance from "../../common/TextTotalBalance";

export default function ResponsiveTableWallet({ data = [], ...restProps }) {
  return (
    <Box
      {...restProps}
      sx={{ backgroundColor: "#191922", borderRadius: "8px" }}
    >
      <TableContainer>
        <Table sx={{ minWidth: 300, padding: 8 }} aria-label="simple table">
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": {
                    border: 0,
                  },
                }}
              >
                <TableCell
                  align="left"
                  sx={{ color: "white", borderBottomColor: "#383841" }}
                >
                  <Box display="flex" justifyContent="space-between">
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent={"flex-start"}
                      gap={2}
                    >
                      {row.type === "deposit" ? (
                        <ResponsiveWalletTag size="small" />
                      ) : (
                        <ResponsiveWalletTag size="small" type="withdraw" />
                      )}
                      <Box display="flex" flexDirection="column" gap={1}>
                        <Typography variant="body2" fontWeight={500}>
                          {row.id}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="rgba(148, 163, 184, 1)"
                        >
                          {row.date}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" flexDirection="column" gap={1}>
                      <TextChangeBalance
                        amount={row.amount}
                        type={row.type === "deposit" ? "add" : "divide"}
                        textAlign="right"
                      />
                      <TextTotalBalance
                        amount={row.balance}
                        textAlign="right"
                      />
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
